<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content point-settings">
    <div slot="header">
      <window-header cmp-title="Point cloud settings" widget-name="pc_settings"></window-header>
    </div>
    <div class="card-body">
      <b-container fluid>
        <b-row>
          <b-col sm="4"><label for="sld_point_budget">Point budget:</label></b-col>
          <b-col sm="8">
            <b-form-select v-model="pointBudget" id="sld_point_budget" :options="Array.from({length: 11}, (x,i) => i).filter(i => !!i).map(i => {
            var  v = i*1000000
            return {
              value: v, text: `${i} million${i > 1 ? 's' : ''}`
            }
          })"></b-form-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="4">
            <label>Min node size:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input v-model="minNodeSize" type="range" min="1" max="1000"
                          step="0.01"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label>FOV:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input v-model="FOV" type="range" min="20" max="100"
                          step="1"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label for="splat_quality">Splat quality high:</label>
          </b-col>
          <b-col sm="8">
            <b-form-checkbox id="splat_quality" v-model="splatQuality" :value="true"
                             :unchecked-value="false"></b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label for="sld_edl_enabled">EDL enabled:</label>
          </b-col>
          <b-col sm="8">
            <b-form-checkbox id="sld_edl_enabled"
                             v-model="EDLEnabled"
                             :value="true"
                             :unchecked-value="false">
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label>EDL radius:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input :disabled="!edl" v-model="EDLRadius" type="range" min="1" max="4"
                          step="0.01"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <label>EDL strength:</label>
          </b-col>
          <b-col sm="8">
            <b-form-input :disabled="!edl" v-model="EDLStrength" type="range" min="0" max="5"
                          step="0.01"></b-form-input>
          </b-col>
        </b-row>
      </b-container>

    </div>
  </b-card>
</template>

<script>
  import WindowHeader from '../common/WindowHeader'

  export default {
    name: 'PointCloudSettings',
    components: {WindowHeader},
    data () {
      return {
        edl: false
      }
    },
    computed: {
      pointBudget: {
        get () {
          if (!window.viewer) {
            return 1000000
          }
          return viewer.getPointBudget()
        },
        set (val) {
          window.viewer && window.viewer.setPointBudget(val)
        }
      },
      EDLEnabled: {
        get () {
          if (!window.viewer) {
            return this.edl
          }
          return window.viewer.getEDLEnabled()
        },
        set (val) {
          this.edl = val
          window.viewer && window.viewer.setEDLEnabled(val)
        }
      },
      EDLStrength: {
        get () {
          if (!window.viewer) {
            return 0
          }
          return window.viewer.getEDLStrength()
        },
        set (val) {
          window.viewer && window.viewer.setEDLStrength(val)
        }
      },
      EDLRadius: {
        get () {
          if (!window.viewer) {
            return 1
          }
          return window.viewer.getEDLRadius()
        },
        set (val) {
          window.viewer && window.viewer.setEDLRadius(val)
        }
      },
      FOV: {
        get () {
          if (!window.viewer) {
            return 20
          }
          return window.viewer.getFOV()
        },
        set (val) {
          window.viewer && window.viewer.setFOV(val)
        }
      },
      splatQuality: {
        get () {
          if (!window.viewer) {
            return false
          }
          return window.viewer.useHQ
        },
        set (val) {
          window.viewer && (window.viewer.useHQ = val)
        }
      },
      minNodeSize: {
        get () {
          if (!window.viewer) {
            return false
          }
          return window.viewer.getMinNodeSize()
        },
        set (val) {
          window.viewer && window.viewer.setMinNodeSize(val)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/PointCloudSettings.vue